module.exports = __webpack_public_path__ + "img/solution-dil-system-pic-3.e618848a.png";